import {styled} from "@mui/material/styles";
import {LoadingButton} from "@mui/lab";

export const ReportLoadingButton = styled(LoadingButton)({
    padding:"0.6rem 1rem 0.6rem 1rem",
    minWidth:'150px',
    background :"#637381",
    boxShadow :"0 0 2px 0 rgba(145, 158, 171, 0.24), 0 16px 32px -4px rgba(145, 158, 171, 0.24)",
    '&:hover':{
        background:"#919EAB"
    }
});

export const reportStyles = {
    button:{
        padding:"0.6rem 1rem 0.6rem 1rem",
        minWidth:'150px'
    },
    boxContainer:{}
}